export const works = [
  {
    id: 0,
    image: "assets/images/portfolio/portfolio-1.png",
    catagory: ["all", "app"],
    name: "El Arca",
    url: "https://elarcaapps.org/",
  },
  {
    id: 1,
    image: "assets/images/portfolio/portfolio-2.png",
    catagory: ["all", "app"],
    name: "Inventry Management System",
    url: "https://jawad606.github.io/client/",
  },
  {
    id: 2,
    image: "assets/images/portfolio/portfolio-3.png",
    catagory: ["all", "app"],
    name: "Ai powered Smart Recruiter",
    url: "https://github.com/Jawad606/AI-powered-Smart-Recruiter.git",
  },
  {
    id: 3,
    image: "assets/images/portfolio/portfolio-4.png",
    catagory: ["all", "card"],
    name: "Mg Full portfolio",
    url: "https://jawad606.github.io/mg-full/",
  },
  {
    id: 4,
    image: "assets/images/portfolio/portfolio-5.png",
    catagory: ["all", "card"],
    name: "Be Filer",
    url: "https://jawad606.github.io/clietn/",
  },
  {
    id: 5,
    image: "assets/images/portfolio/portfolio-6.png",
    catagory: ["all", "card"],
    name: "Airbnb Clone",
    url: "https://airbnb-clone-jawad606.vercel.app/",
  },
];
